import Authorize from './authorize'
import Logout from './logout'
export default { Authorize, Logout }
